import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../core/services/api/api.service';
import { Statistics } from '../../../models/statistics';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class StatisticsService {
  getStatistics(): Observable<Statistics> {
    return this.apiService.get<Statistics>(`/dashboard/statistics`);
  }

  getStatusApi(): Observable<JSON> {
    return this.apiService.get<JSON>(`/dashboard/status/api`);
  }

  getStatusDashboard(): Observable<JSON> {
    return this.apiService.get<JSON>(`/dashboard/status/api`);
  }

  getStatusAndroid(): Observable<JSON> {
    return this.apiService.get<JSON>(`/dashboard/status/android/api`);
  }

  getStatusApple() {
    return this.apiService.get<JSON>(`/dashboard/status/apple/api`);
  }

  constructor(private apiService: ApiService, private http: HttpClient) {}
}
